// This file was automatically generated from appchart.dialog.problemHx.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.problemHx');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.ptProblems');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.problemHx.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DialogContainer"><div class="el8ItemButtonWrapRight mv5"><button type="button" class="el8button add-problem-trigger el8ItemButton">+ Add Problem</button></div><h4 class="el8SectionHeaderNoCollapse">Active Problems</h4><ol class="active-problems-section"></ol><h4 class="el8SectionHeaderNoCollapse mt20">Controlled Problems</h4><ol class="controlled-problems-section"></ol><h4 class="el8SectionHeaderNoCollapse mt20">Resolved Problems</h4><ol class="resolved-problems-section"></ol><div class="padb50"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.problemHx.problemList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.isDocumentedAsNone) {
    output.append('<li class="el8ItemHover allergyNone more-actions-trigger am-highlight"><div class="el8ItemButtonContainer"><button tabindex="-1" type="button" class="el8button el8ActionButton">Actions<span class="el8ButtonDropdownIcon"></span></button></div><p>');
    el8.template.ptdata.ptProblems.documentedAsNoneSummary(null, output);
    output.append('</p></li>');
  } else {
    if (! opt_data.problems.length) {
      output.append('<li class="el8SectionEmpty">None</li>');
    } else {
      var pList2342 = opt_data.problems;
      var pListLen2342 = pList2342.length;
      for (var pIndex2342 = 0; pIndex2342 < pListLen2342; pIndex2342++) {
        var pData2342 = pList2342[pIndex2342];
        el8.template.appchart.dialog.problemHx.problem(soy.$$augmentData(pData2342, {showDualCodingDisabled: opt_data.showDualCodingDisabled}), output);
      }
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.problemHx.problem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li data-id="', soy.$$escapeHtml(opt_data.id), '" class="el8ItemHover problem', soy.$$escapeHtml(opt_data.status), ' am-highlight more-actions-trigger"><div class="el8ItemButtonContainer"><button tabindex="-1" type="button" class="el8button el8ActionButton">Actions<span class="el8ButtonDropdownIcon"></span></button></div><div class="el8DateYrMMDD">', (soy.$$escapeHtml(opt_data.startDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.startDate)) : ''), '</div><p class="el8ItemWithDate"><span class="el8Preserve">');
  el8.template.ptdata.ptProblems.detailedDescription(opt_data, output);
  output.append('<div class="ml75 el8SystemText">Last modified on ', (soy.$$escapeHtml(opt_data.createDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.createDate)) : ''), '</div></span></p>', (opt_data.details) ? '<p class="el8ItemWithDate el8ItalicText el8Preserve">' + soy.$$escapeHtml(opt_data.details) + '</p>' : '', '</li>');
  if (!opt_sb) return output.toString();
};
